export const heroSlides = [
  {
    id: "h1",
    movieId: "m1",
    tag: "本周热映",
    title: "星际苍穹",
    subtitle: "当深空不再沉默，人类要为自己的选择找到答案。",
    meta: "科幻 · 冒险 / 2024 / 中国大陆",
    rating: 8.7,
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20a%20distant%20glowing%20planet%20and%20a%20tiny%20spaceship%20silhouette%2C%20deep%20navy%20cosmos%20with%20amber%20nebula%20glow%2C%20abstract%20artistic%20stylised%20background%2C%20dramatic%20lighting%2C%20highly%20detailed%20concept%20art%2C%20no%20text&width=1920&height=1080&seq=hero-slide-01&orientation=landscape",
  },
  {
    id: "h2",
    movieId: "m5",
    tag: "口碑之作",
    title: "深海回声",
    subtitle: "来自海沟深处的信号，正等待着被听见。",
    meta: "科幻 · 惊悚 / 2025 / 美国",
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Stylised%20deep%20ocean%20abyss%20scene%20with%20a%20faintly%20glowing%20submersible%20and%20bioluminescent%20particles%2C%20deep%20navy%20and%20teal%20water%20with%20warm%20orange%20glow%2C%20abstract%20artistic%20background%2C%20dramatic%20lighting%2C%20highly%20detailed%20concept%20art%2C%20no%20text&width=1920&height=1080&seq=hero-slide-02&orientation=landscape",
  },
  {
    id: "h3",
    movieId: "m11",
    tag: "人气推荐",
    title: "幻影城市",
    subtitle: "如果记忆可以买卖，你愿意用什么来交换真实的自己？",
    meta: "动作 · 科幻 / 2025 / 中国大陆",
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Futuristic%20neon%20city%20canyon%20at%20night%20with%20glowing%20signage%20and%20light%20trails%2C%20deep%20navy%20and%20teal%20with%20warm%20orange%20neon%20reflections%2C%20abstract%20artistic%20stylised%20background%2C%20cinematic%20lighting%2C%20highly%20detailed%20concept%20art%2C%20no%20text&width=1920&height=1080&seq=hero-slide-03&orientation=landscape",
  },
  {
    id: "h4",
    movieId: "m17",
    tag: "烧脑新作",
    title: "量子裂缝",
    subtitle: "同一个人的两条时间线，必须做出截然相反的选择。",
    meta: "科幻 · 悬疑 / 2025 / 美国",
    rating: 8.8,
    image: "https://readdy.ai/api/search-image?query=Abstract%20quantum%20physics%20visual%20with%20glowing%20geometric%20light%20lines%20and%20mirror%20symmetry%2C%20deep%20navy%20and%20teal%20with%20warm%20orange%20glow%2C%20stylised%20artistic%20background%2C%20dramatic%20lighting%2C%20highly%20detailed%20concept%20art%2C%20no%20text&width=1920&height=1080&seq=hero-slide-04&orientation=landscape",
  },
  {
    id: "h5",
    movieId: "t2",
    tag: "热门剧集",
    title: "迷雾档案",
    subtitle: "档案里的每一页都在说谎，真相藏在无人回望的过去。",
    meta: "悬疑 · 犯罪 / 2023 / 中国大陆",
    rating: 8.8,
    image: "https://readdy.ai/api/search-image?query=Stylised%20noir%20scene%20of%20scattered%20case%20files%20and%20evidence%20under%20a%20single%20lamp%20in%20darkness%2C%20deep%20navy%20tones%20with%20warm%20orange%20light%2C%20abstract%20artistic%20background%2C%20dramatic%20lighting%2C%20highly%20detailed%20concept%20art%2C%20no%20text&width=1920&height=1080&seq=hero-slide-05&orientation=landscape",
  },
];